"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ExtendedWorkItem_1 = __importDefault(require("@Components/WorkItemV2/ExtendedWorkItem"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const ShareDisplay_1 = require("@Components/WorkItemV2/ShareDisplay");
const Status_1 = __importDefault(require("@Components/Status"));
const get_source_name_by_source_id_1 = require("@App/helpers/work-entities/utils/get-source-name-by-source-id");
const get_submission_path_1 = require("@App/helpers/get-submission-path");
const contexts_1 = require("@App/contexts");
const HistoryExtendedWorkItem = (props) => {
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { work, fetchType } = props;
    const submissionDate = work.submissionDate &&
        new Date(work.submissionDate).toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        });
    const submissionPath = (0, get_submission_path_1.getSubmissionPath)(rightsholderStore.currentRightsholderId, work.id, fetchType);
    return (react_1.default.createElement(ExtendedWorkItem_1.default, { work: work, fields: [
            { title: 'Submission Date', value: submissionDate },
            { title: 'Submission Source', value: (0, get_source_name_by_source_id_1.getSourceNameBySourceId)(work === null || work === void 0 ? void 0 : work.sourceId) },
            { title: 'ISWC', value: work.iswc },
            { title: 'Member Work Identifier', value: work.rightsholderProprietaryId },
        ], catalogPath: submissionPath },
        react_1.default.createElement(ShareDisplay_1.ShareDisplay, { share: work.totalKnownShares, highlight: true, tooltip: react_1.default.createElement(CustomToolTip_1.default, { title: 'Your Total Submitted Shares:', info: 'This reflects total shares you have submitted to The MLC. ' +
                    'These submitted shares are subject to review and approval by The MLC before being processed.' }) }),
        work.registrationHistoryStatus && (react_1.default.createElement(Status_1.default, { status: work.registrationHistoryStatus === 'Unknown' ? 'Submitted' : work.registrationHistoryStatus }))));
};
exports.default = HistoryExtendedWorkItem;
